// extracted by mini-css-extract-plugin
export default {"hiClientAdmin1":"SetupOrganisation_hiClientAdmin1__ufT65","goremIpsumDolor1":"SetupOrganisation_goremIpsumDolor1__bWNGQ","headerTitle":"SetupOrganisation_headerTitle__rYC3x"};